// Keenthemes' plugins
window.KTComponents = require('../resources/src/js/components/_init.js');
window.KTUtil = require('../resources/src/js/components/util.js');
window.KTApp = require('../resources/src/js/components/app.js');
window.KTEventHandler = require('../resources/src/js/components/event-handler.js');
window.KTBlockUI = require('../resources/src/js/components/blockui.js');
window.KTCookie = require('../resources/src/js/components/cookie.js');
window.KTDialer = require('../resources/src/js/components/dialer.js');
window.KTDrawer = require('../resources/src/js/components/drawer.js');
window.KTFeedback = require('../resources/src/js/components/feedback.js');
window.KTImageInput = require('../resources/src/js/components/image-input.js');
window.KTMenu = require('../resources/src/js/components/menu.js');
window.KTPasswordMeter = require('../resources/src/js/components/password-meter.js');
window.KTScroll = require('../resources/src/js/components/scroll.js');
window.KTScrolltop = require('../resources/src/js/components/scrolltop.js');
// window.KTSearch = require('../resources/src/js/components/search.js');
window.KTStepper = require('../resources/src/js/components/stepper.js');
window.KTSticky = require('../resources/src/js/components/sticky.js');
window.KTSwapper = require('../resources/src/js/components/swapper.js');
window.KTToggle = require('../resources/src/js/components/toggle.js');

// Layout base js
window.KTLayoutHeader = require('../resources/src/js/layout/header.js');
// window.KTLayoutSearch = require('../resources/src/js/layout/search.js');
window.KTThemeMode = require('../resources/src/js/layout/theme-mode.js');
window.KTThemeModeUser = require('../resources/src/js/layout/theme-mode-user.js');
window.KTAlert =  require('../resources/src/js/components/alert.js');
window.TWICGlobal =  require('../resources/src/js/components/twic-global.js');
